"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface to the browser console so production traces include the
    // original error message + stack, not just Next.js's generic shell.
    // eslint-disable-next-line no-console
    console.error("[app] render error caught by app/error.tsx:", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-bg">
      <div className="w-full max-w-sm text-center">
        <div className="w-14 h-14 rounded-2xl bg-forest flex items-center justify-center mx-auto mb-4">
          <span className="text-white text-xl font-bold">DE</span>
        </div>
        <h1 className="text-lg font-semibold text-text mb-2">
          Something didn&apos;t render correctly
        </h1>
        <p className="text-sm text-muted mb-6">
          Your account is fine — we just hit an unexpected gap in the data
          this screen needed. Try again, or head back home.
        </p>
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => reset()}
            className="w-full py-3 bg-forest text-white rounded-xl font-medium text-sm hover:bg-forest-med transition-colors"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => {
              if (typeof window !== "undefined") {
                window.location.href = "/";
              }
            }}
            className="w-full py-3 bg-card border border-border text-text rounded-xl font-medium text-sm hover:bg-secondary transition-colors"
          >
            Go home
          </button>
        </div>
        {error.digest ? (
          <p className="mt-4 text-[11px] text-muted">
            Reference: <span className="font-mono">{error.digest}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
}
